import React from 'react';
import { useNavigate } from 'react-router-dom';
import { trackPopupClick } from '../services/analytics';
import './AppPopup.css';

const AppPopup = ({ isOpen, content, onClose, version }) => {
  const navigate = useNavigate();

  if (!isOpen || !content) return null;

  const handleAction = () => {
    // Tracker le clic en arrière-plan (non bloquant)
    trackPopupClick(version || 'unknown', content.ctaLink || 'none').catch(() => {
      // Erreur silencieuse
    });
    
    // Si c'est une URL externe (commence par http:// ou https://)
    if (content.ctaLink && (content.ctaLink.startsWith('http://') || content.ctaLink.startsWith('https://'))) {
      window.open(content.ctaLink, '_blank', 'noopener,noreferrer');
      onClose();
    } 
    // Si c'est une route interne (commence par /)
    else if (content.ctaLink && content.ctaLink.startsWith('/')) {
      onClose();
      navigate(content.ctaLink);
    } 
    // Sinon, juste fermer le popup
    else {
      onClose();
    }
  };

  return (
    <div className="app-popup-overlay" onClick={onClose}>
      <div className="app-popup-content" onClick={(e) => e.stopPropagation()}>
        {/* Bouton fermer */}
        <button className="app-popup-close" onClick={onClose} aria-label="Fermer">
          ✕
        </button>

        {/* Image optionnelle */}
        {content.imageUrl && (
          <div className="app-popup-image">
            <img src={content.imageUrl} alt={content.title || 'Popup'} />
          </div>
        )}

        {/* Titre */}
        {content.title && (
          <h2 className="app-popup-title">{content.title}</h2>
        )}

        {/* Message */}
        {content.message && (
          <p className="app-popup-message">{content.message}</p>
        )}

        {/* Bouton d'action */}
        <button className="app-popup-cta" onClick={handleAction}>
          {content.ctaText || 'Compris !'}
        </button>
      </div>
    </div>
  );
};

export default AppPopup;

